import { ActionType, createReducer } from 'typesafe-actions';
import {
  addConfirmedBetAction,
  clearAllBetsAction,
  updatePlacedBetsAction,
  setConfirmedBetAction,
} from './actions';
import { EMPTY_BET } from './data';
import { IBetState } from './types';

export const betState: IBetState = {
  bets: {
    placed: {
      past: [],
      present: EMPTY_BET,
    },
    confirmed: [],
  },
};

const actions = {
  updatePlacedBetsAction,
  clearAllBetsAction,
  addConfirmedBetAction,
  setConfirmedBetAction,
};

export const betReducer = createReducer<IBetState, ActionType<typeof actions>>(betState)
  .handleAction(updatePlacedBetsAction, (state, { payload }) => ({
    ...state,
    bets: {
      ...state.bets,
      placed: { ...payload },
    },
  }))
  .handleAction(clearAllBetsAction, (state) => ({
    ...state,
    bets: {
      ...state.bets,
      placed: {
        past: [],
        present: EMPTY_BET,
      },
      confirmed: [],
    },
  }))
  .handleAction(addConfirmedBetAction, (state, { payload: confirmedBet }) => ({
    ...state,
    bets: {
      ...state.bets,
      confirmed: [...state.bets.confirmed, ...confirmedBet],
    },
  }))
  .handleAction(setConfirmedBetAction, (state, { payload: confirmedBets }) => ({
    ...state,
    bets: {
      ...state.bets,
      confirmed: confirmedBets,
    },
  }));
